import gql from 'graphql-tag';
import { IsPageOwnerFragment } from '../../types/__generated__';
import { useAuthenticateUser } from './useAuthenticateUser';
import usePageQuery, { buildQuery } from './usePageQuery';

const FRAGMENT = buildQuery(gql`
  fragment IsPageOwner on Page {
    legacyId
    owner {
      id
      legacyId
      name
    }
  }
`);

export function usePageOwner() {
  const { accessToken } = useAuthenticateUser();
  const { data, loading, error } = usePageQuery<IsPageOwnerFragment>(FRAGMENT);

  const userGuid = accessToken?.guid;
  const pageOwnerId = data?.owner?.legacyId;

  const unauthenticatedUser = {
    isPageOwner: false,
    isCheckingPageOwner: loading,
    data,
    error,
  };

  if (loading || !userGuid || !pageOwnerId) {
    return unauthenticatedUser;
  }

  return {
    isPageOwner: userGuid === pageOwnerId,
    isCheckingPageOwner: loading,
    data,
    error,
  };
}
